import React, { useEffect, useRef, useState } from 'react'
import '../Styles/Home.css';
import { Search } from '@mui/icons-material';
import { InputBase } from '@mui/material';
import Accordian from '../Utilities/Accordian/Accordian';
import Tile1 from '../Utilities/Tile1/Tile1';
import Repository from '../Repository/Repository';
import { Link } from 'react-router-dom';
import { fetchAllArticles } from '../Functions';
import {getAnalytics, logEvent} from "firebase/analytics";
import { Helmet } from 'react-helmet';
import BwgAd from '../Assets/Bwg_ad.png'
import FloatingDots from '../Utilities/FloatingDots/FloatingDots';
function Home() {
  const analytics = getAnalytics();
  const initialized = useRef(false);
  //const [articles, setArticles] = useState(Repository);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
  const getBlogs = async () => {
    try {
      // Call the fetchAllArticles function and get the articles
      const tomato = await fetchAllArticles();
      
      // ✅ Pin the specific article to the top
      const pinnedArticleId = 'Articles-Zo7drLqKW4ZZAmw7RKRDTzWT1Pj1-1763029710356';
      const pinnedArticle = tomato.find(article => article.articleUID === pinnedArticleId);
      const otherArticles = tomato.filter(article => article.articleUID !== pinnedArticleId);
      
      // Put pinned article first, then the rest
      const sortedBlogs = pinnedArticle ? [pinnedArticle, ...otherArticles] : tomato;
      
      // Update the state with the sorted articles
      setBlogs(sortedBlogs);
      setFilteredData(sortedBlogs);
      localStorage.setItem('storedArticles', JSON.stringify(sortedBlogs));
    } catch (error) {
      console.error("Error fetching articles:", error);
    }
  };

  getBlogs();
  if (!initialized.current) {
    initialized.current = true
    // My actual effect logic...
    logEvent(analytics, 'Visit', { name: 'Home Page'})
  }
  return () => {}
}, []);
 
  /*useEffect(() => {
    return () => {}
  }, [articles]);*/

  const [searchInput, setSearchInput] = useState('');
  const [filteredData, setFilteredData] = useState(blogs);
  const handleSearchInputChange = (e) => {
    const input = e.target.value.toString().toLowerCase();
    setSearchInput(input);
    // Filter the data based on the input
    const filtered = blogs.filter(item => {
        return Object.values(item).some(value =>
            value.toString().toLowerCase().includes(input)
        );
    });
    setFilteredData(filtered);
};


  return (
    <div className='Home-container'>
          <Helmet>
            <title>The Trehan | Feed</title>
            <meta name='description' content='The Trehan offers strategic clarity, risk assessments, and data-backed reports on Asia’s shifting landscape—designed for businesses, institutions, and media seeking reliable insights and actionable depth.' data-react-helmet="true"/>
            <meta name="theme-color" content="#000000" data-react-helmet="true"/>
            <meta name='keywords' content='Asia think tank, geopolitical insights, strategic foresight, economic risk analysis, business intelligence Asia, Indo-Pacific reports, war gaming, India market entry, Asia business strategy, political risk workshops' data-react-helmet="true"/>  
            <link rel='canonical' href='/'/>
          </Helmet>
          {/* Floating Dots Background */}
          
            <div className='Home-Accordian'><Accordian/></div>
            <div className="Home-landing">
                <h1 className='Home-title'>The Trehan</h1>
                <div className="Home-searchBar">
                    <div className="Home-searchBar-deco"><Search style={{fontSize:'1.2rem'}} /></div>
                    <InputBase sx={{ ml: 1, flex: 1 }} placeholder="Search" value={searchInput} onChange={handleSearchInputChange} inputProps={{ 'aria-label': 'search' }}/>
                </div>
                <p className='Home-openingStatement'>A geopolitical and geoeconomic think tank dedicated to enhancing situational awareness of businesses, enabling them to navigate complex global dynamics. None of our content is conceptualised, written or reworded with the use of Ai. The use of Ai is limited to spell check and for search engine tasks</p>
                {searchInput && ( // Render results only if searchInput is not empty
                <ul className="Home-search-results transition">
                      {filteredData.map(item => (
                          <Link to={`/article/${item.articleUID}`} key={item.articleUID} className="Home-search-result">
                              {item.category.toUpperCase()} - {item.title}
                          </Link>
                      ))}
                </ul>
                )}
                <Link to="/wargaming" className='Bwg-ad'><img alt='bwg_ad' className='Bwg-ad-img' src={BwgAd}/></Link>
            
            </div>

            <div className="Home-latest">
              <h2 className='Home-latest-label'>Latest</h2>
              <div className="Home-latest-articles">
                {blogs.map((blog) => (
                  <>
                  {blog.publish && 
                      <Tile1 date={blog.publishedDate} articleUID={blog.articleUID} title={blog.title} author={blog.author} key={blog.uid}  featureImageURL={blog.featureImageURL} 
                      />
                  }
                  </>
                ))}
              </div>
            </div>
        

    </div>
  )
}

export default Home

//<div className='Home-FloatingDots'><FloatingDots /></div>